export default __webpack_public_path__ + "static/media/Montserrat-Light.23984463.woff";